import { VariantInfo } from '@/tsClasses/VariantInfoForProteinExchange';

/**
 * Compares two variant info objects ignoring exclusionCriterion property.
 * @param variant1
 * @param variant2
 * @returns true if relevant properties are the same
 */
export const areVariantsEquivalent = (
  variant1: VariantInfo,
  variant2: VariantInfo
): boolean => {
  return (
    variant1.accession === variant2.accession &&
    variant1.gene_sort === variant2.gene_sort &&
    variant1.protein_change === variant2.protein_change &&
    variant1.title === variant2.title
  );
};
